export const getDefaultOption = () => {
  return { instanceId: `checkbox-${Date.now()}`, text: '', isActive: false };
};
